import instance from './instance'

/** 违法举报信息上传接口 */
function p_report_post (opts) {
  return instance({
    method: 'post',
    url: '/vio/report/submit',
    opts: opts
  })
}
/** 地址预校验 */
function addressCheck (opts) {
  return instance({
    method: 'post',
    url: '/vio/report/addressCheck',
    opts: opts
  })
}
/** 材料补充上传
 */
function supplement_post (opts) {
  return instance({
    method: 'post',
    url: '/vio/report/supplement/submit',
    opts: opts
  })
}
/** url文件上传
 */
 function uploadurl_post (opts) {
  return instance({
    method: 'post',
    url: '/file/uploadFileUrl?url=' + opts.url,
    opts: {}
  })
}
/** 上传文件图片或者视频 */
function p_upload_post (opts) {
  return instance({
    method: 'post',
    url: '/file/upload',
    opts: opts
  })
}
/** 保存奖励银行信息 */
function p_reward_saveBankInfo_post (opts) {
  return instance({
    method: 'post',
    url: '/vio/report/reward/saveBankInfo',
    opts: opts
  })
}

/** 获取违法列表 */
function p_getVioList_get (opts) {
  return instance({
    method: 'get',
    url: '/vio/report/history',
    opts: opts
  })
}

/** 字典获取
 */
function commonDict (dmlb) {
  return instance({
    method: 'get',
    url: '/common/dict/' + dmlb

  })
}
/** 字典获取
 */
 function userInfo () {
  return instance({
    method: 'get',
    url: '/user/info'

  })
}
// /** 获取token */
// function p_getCode_get (opts) {
//   return instance({
//     method: 'get',
//     url: '/p/getCode',
//     opts: opts
//   })
// }

// /** 下载图片接口 */
// function p_download_id_get (opts) {
//   return instance({
//     method: 'get',
//     url: convertRESTAPI('/p/download/{id}', opts),
//     opts: opts
//   })
// }

/** 告知 */
function p_getNotice_get (opts) {
  return instance({
    method: 'get',
    url: '/common/config?code=' + opts

  })
}
/** 获取手机端表单配置 **/
function p_getAppConfig_get () {
  return instance({
    method: 'get',
    url: '/common/appConfig'

  })
}
/** 获取token */
function dealKeyLogin_get (opts) {
  return instance({
    method: 'get',
    url: '/auth/dealKeyLogin?dealKey=' + opts

  })
}

/** HEIC转JPG文件转换 **/
function p_changeHeicToJpg_post (opts) {
  return instance({
    method: 'post',
    url: '/common/changeHeicToJpg',
    opts: {
      data: opts.data,
      responseType: 'blob'
    }
  })
}
/** OSS直传签名获取 */
function p_oss_policy_post (opts) {
  return instance({
    method: 'post',
    url: '/ossFile/policy',
    opts: opts
  })
}
/** OSS直传完成核验 */
function p_oss_complete_post (opts) {
  return instance({
    method: 'post',
    url: '/ossFile/complete',
    opts: opts
  })
}

export {
  addressCheck,
  p_report_post,
  p_upload_post,
  p_reward_saveBankInfo_post,
  userInfo,
  uploadurl_post,
  p_getVioList_get,
  supplement_post,
  commonDict,
  p_getNotice_get,
  dealKeyLogin_get,
  p_getAppConfig_get,
  p_changeHeicToJpg_post,
  p_oss_policy_post,
  p_oss_complete_post
}



// WEBPACK FOOTER //
// ./src/api/wfjb/index.js